import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {LocationCardScratchpadState} from '../../scratchpad/locationCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';

const setLocationTargetingMethodToolSchema = z.object({
  targetingMethod: z
    .number()
    .describe(
      'The location targeting method to set. Options: 0 (Nearest Location), 10 (By Zip Code), 12 (By Zip Code From DSP), 20 (By DMA), 30 (Specific Store)',
    ),
});

export default function setLocationTargetingMethodTool() {
  async function execute(
    params: ToolExecuteParams<
      typeof setLocationTargetingMethodToolSchema,
      LocationCardScratchpadState
    >,
  ) {
    const {targetingMethod} = params.input;
    const {agentScratchpad} = params.toolUtils;
    const validatedScratchpad = validateAgentScratchpad<LocationCardScratchpadState>(
      agentScratchpad,
      NodeType.STORE,
    );

    if (!targetingMethod) {
      return toolResult('No targeting method provided');
    }

    validatedScratchpad.card.locationTargetingMethod = targetingMethod;

    return toolResult(`Location targeting method set to: ${targetingMethod}`);
  }

  return tool({
    name: V2CardAgentToolName.SetLocationTargetingMethod,
    displayName: 'Set location targeting method',
    description:
      'Set the location targeting method for the location card (Nearest Location, By Zip Code, By DMA, Specific Store)',
    execute,
    inputSchema: setLocationTargetingMethodToolSchema,
  });
}
